import { CHANNELS } from 'constants/Channels';
import ufeApi from 'services/api/ufeApi';

// Update subscription with a new address https://jira.sephora.com/browse/SUBS-199

function addSubscriptionAddress(subscriptionId, addressPaymentData = {}) {
    const { sdnUfeAPIUserKey } = Sephora.configurationSettings;
    const { country, language } = Sephora.renderQueryParams;
    const url = `/gway/v1/replenishment/${subscriptionId}/addresses?apikey=${sdnUfeAPIUserKey}`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Site-Locale': country,
            'Site-Language': language,
            'x-requested-source': CHANNELS.RWD
        },
        body: JSON.stringify(addressPaymentData)
    };

    return ufeApi.makeRequest(url, options).then(data => (data.errors || data?.responseStatus >= 400 ? Promise.reject(data) : data));
}

export default { addSubscriptionAddress };
